import { render, staticRenderFns } from "./DataAudit.vue?vue&type=template&id=209a3beb&scoped=true"
import script from "./DataAudit.vue?vue&type=script&lang=js"
export * from "./DataAudit.vue?vue&type=script&lang=js"
import style0 from "./DataAudit.vue?vue&type=style&index=0&id=209a3beb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209a3beb",
  null
  
)

export default component.exports